<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="8">
        <PeerVideo
          :remoteVideoStream="remoteVideoStream"
          :remoteAudioStream="remoteAudioStream"
        />
      </v-col>
      <v-col cols="12" md="4">
        <PeerChat :message="message" @chatSend="chatSend" @muted="muted" :title="alias" />
        <v-row>
          <v-col cols="6">
            <v-file-input :dense="true" label="File" v-on:change="fileSelect"></v-file-input>
          </v-col>
          <v-col cols="6">
            <a
              v-if="filePercentage == 0 || filePercentage > 99"
              :href="receivedFileRef"
              :download="targetFileName"
              >{{ targetFileName }}</a>
            <v-progress-linear
              v-else
              :value="filePercentage"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
var configuration = {
  iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
};
const reFileSend = /size:(\d+),name:(.+)/;
import { mapState } from "vuex";
import { db } from "./utils-firebase";
import PeerVideo from "./PeerVideo.vue";
import PeerChat from "./PeerChat.vue";

export default {
  props: ["localVideoStream", "localAudioStream", "userId", "type"],
  components: {
    PeerVideo,
    PeerChat,
  },
  data() {
    return {
      peer: null,
      remoteVideoStream: null,
      remoteAudioStream: null,
      dataR: null,
      dataS: null,
      dataFR: null,
      dataFS: null,
      message: {},
      indexTeacherSDP: 0,
      indexStudentSDP: 0,
      memberListener: null,
      alias: null,
      answerCreated: false,
      offerCreated: false,
      fileBuf: [],
      fileSize: 0,
      targetFileSize: 0,
      targetFileName: "",
      receivedFileRef: null,
    };
  },
  computed: {
    ...mapState(["roomId"]),
    filePercentage() {
      if (this.targetFileSize == 0) {
        return 0;
      } else {
        return (this.fileSize / this.targetFileSize) * 100;
      }
    },
  },

  mounted() {
    this.peer = new RTCPeerConnection(configuration);
    this.dataS = this.peer.createDataChannel("sendDataChannel");
    this.dataFS = this.peer.createDataChannel("fileTransfer");
    this.peer.ondatachannel = (evt) => {
      if (evt.channel.label == "sendDataChannel") {
        this.dataR = evt.channel;
        this.dataR.onmessage = (e) => {
          var m = e.data.match(reFileSend);
          if (m && m.length > 2) {
            this.targetFileSize = parseInt(m[1]);
            this.targetFileName = m[2];
          } else {
            this.message = e.data;
          }
        };
      }
      if (evt.channel.label == "fileTransfer") {
        this.dataFR = evt.channel;
        this.dataFR.onmessage = (e) => {
          this.fileBuf.push(e.data);
          this.fileSize += e.data.byteLength;
          if (this.fileSize == this.targetFileSize) {
            var received = new window.Blob(this.fileBuf);
            this.fileBuf = [];
            this.fileSize = 0;
            this.receivedFileRef= URL.createObjectURL(received);
          }
        };
      }
    };

    this.peer.onicecandidate = (evt) => {
      // 8) ICE candidate is notified -> put it on firebase
      if (evt.candidate) {
        if (this.type == "teacher") {
          db.pushTeacherSDP(
            this.roomId,
            this.userId,
            JSON.stringify(evt.candidate)
          );
        } else {
          db.pushStudentSDP(
            this.roomId,
            this.userId,
            JSON.stringify(evt.candidate)
          );
        }
      }
    };

    this.peer.oniceconnectionstatechange = (evt) => {
      console.log("RTCConnection.oniceconnectionstatechange evt="+evt)
      this.$emit("onStateChanged", evt.target.iceConnectionState, this.userId);
    };

    this.peer.ontrack = (evt) => {
      if (evt.track.kind == "audio") {
        this.remoteAudioStream = evt.streams[0];
      }
      if (evt.track.kind == "video") {
        this.remoteVideoStream = evt.streams[0];
      }
    };

    this.localVideoStream
      .getTracks()
      .forEach((t) => this.peer.addTrack(t, this.localVideoStream));
    this.localAudioStream
      .getTracks()
      .forEach((t) => this.peer.addTrack(t, this.localAudioStream));

    if (this.type == "teacher") {
      this.peer.createOffer().then(this.onCreateOfferSuccess);
    }

    this.memberListener = db.watchMember(
      this.roomId,
      this.userId,
      this.memberUpdated
    );
  },

  beforeDestroy() {
    if (this.dataS) {
      this.dataS.close();
    }
    if (this.dataR) {
      this.dataR.close();
    }
    if (this.dataFS) {
      this.dataFS.close();
    }
    if (this.dataFR) {
      this.dataFR.close();
    }
    if (this.peer) {
      this.peer.close();
    }
    this.memberListener();
    this.answerCreated = false;
    this.offerCreated = false;
  },

  methods: {
    async teacherUpdated(d) {
      console.assert(this.type == "teacher");
      if (d.studentSDP != "" && this.answerCreated == false) {
        this.answerCreated = true;
        console.log("*** CREATE ANSWER ***");
        // 7) set remote(student's) description
        var answer = new RTCSessionDescription({
          type: "answer",
          sdp: d.studentSDP,
        });
        await this.peer.setRemoteDescription(answer);
        db.setSDP(this.roomId, this.userId, { studentSDP: "" });
        return;
      }

      var iceString, iceCandidate;
      while (d.studentSDPs && this.indexStudentSDP < d.studentSDPs.length) {
        iceString = d.studentSDPs[this.indexStudentSDP++];
        iceCandidate = new RTCIceCandidate(JSON.parse(iceString));
        await this.peer
          .addIceCandidate(iceCandidate)
          .then(() => {
            console.log("teacher addIceCandidate succeeded");
          })
          .catch((e) => {
            console.log("teacher addIceCandidate:" + e);
          });
      }
    },

    async studentUpdated(d) {
      console.assert(this.type == "student");
      if (d.teacherSDP != "" && this.offerCreated == false) {
        this.offerCreated = true;
        console.log("*** CREATE OFFER ***");
        // 3) student sets remote(teacher's) description
        var offer = new RTCSessionDescription({
          type: "offer",
          sdp: d.teacherSDP,
        });
        this.peer.setRemoteDescription(offer);
        db.setSDP(this.roomId, this.userId, { teacherSDP: "" });

        // 4) student creates Answer (by student)
        const answer = await this.peer.createAnswer();
        await this.onCreateAnswerSuccess(answer);
        return;
      }

      var iceString, iceCandidate;
      while (d.teacherSDPs && this.indexTeacherSDP < d.teacherSDPs.length) {
        iceString = d.teacherSDPs[this.indexTeacherSDP++];
        iceCandidate = new RTCIceCandidate(JSON.parse(iceString));
        this.peer
          .addIceCandidate(iceCandidate)
          .then(() => {
            console.log("student addIceCandidate succeeded");
          })
          .catch((e) => {
            console.log("student addIceCandidate:" + e);
          });
      }
    },

    async memberUpdated(doc) {
      if (!doc.exists) {
        return;
      }
      var d = doc.data();
      if (this.alias == null) {
        this.alias = d.name;
      }
      if (this.type == "teacher") {
        await this.teacherUpdated(d);
      }
      if (this.type == "student") {
        await this.studentUpdated(d);
      }
    },

    async onCreateOfferSuccess(desc) {
      console.assert(this.type == "teacher");
      // 1) teacher sets local(teacher's) description
      await this.peer
        .setLocalDescription(desc)
        .then(() => {
          console.log("teacher setLocalDescription succeeded");
        })
        .catch((e) => {
          console.log("teacher setLocalDescription:" + e);
        });

      // 2) teacher sets local(teacher's) description on firebase
      db.setSDP(this.roomId, this.userId, {
        teacherSDP: this.peer.localDescription.sdp,
      });
    },

    async onCreateAnswerSuccess(desc) {
      console.assert(this.type == "student");
      // 5) student sets local(student's) description
      await this.peer
        .setLocalDescription(desc)
        .then(() => {
          console.log("student setLocalDescription succeeded");
        })
        .catch((e) => {
          console.log("student setLocalDescription:" + e);
        });

      // 6) student sets local(student's) description on firebase
      db.setSDP(this.roomId, this.userId, {
        studentSDP: this.peer.localDescription.sdp,
      });
    },

    chatSend(s) {
      if (this.dataS) {
        this.dataS.send(s);
      }
    },
    
    muted(v){
      if (this.localAudioStream) {
        var audioTrack = this.localAudioStream.getAudioTracks()[0];
        audioTrack.enabled = v;
      }
    },

    fileSelect(file) {
      if (this.dataS && this.dataFS && file) {
        this.dataS.send("size:" + file.size + ",name:" + file.name);

        var chunkSize = 16384;
        var sliceFile = (offset) => {
          var reader = new window.FileReader();
          reader.onload = (() => {
            return (e) => {
              this.dataFS.send(e.target.result);
              console.log( e.target.result.byteLength + " bytes sent")
              if (file.size > offset + e.target.result.byteLength) {
                window.setTimeout(sliceFile, 0, offset + chunkSize);
              }
            };
          })(file);
          var slice = file.slice(offset, offset + chunkSize);
          reader.readAsArrayBuffer(slice);
        };
        sliceFile(0);
      }
    },
  },
};
</script>
